import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';
import Home from './Home';
import Ticket from './Ticket';
import Header from './components/header';
import Footer from './components/footer';
import Faq from './Faq';
import "@fontsource/poppins";

ReactGA.initialize('YOUR_GA_ID'); // Replace with your GA ID

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const STATIC_PASSWORD = 'bandland2026'; // Change this to your desired password

  useEffect(() => {
    
      ReactGA.pageview(window.location.pathname);
    
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === STATIC_PASSWORD) {
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password');
      setPassword('');
    }
  };

  // if (!isAuthenticated) {
  //   return (
  //     <div style={{
  //       display: 'flex',
  //       justifyContent: 'center',
  //       alignItems: 'center',
  //       minHeight: '100vh',
  //       backgroundColor: '#1a1a1a',
  //       color: '#fff',
  //       fontFamily: 'Arial, sans-serif'
  //     }}>
  //       <div style={{
  //         background: '#2a2a2a',
  //         padding: '40px',
  //         borderRadius: '10px',
  //         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
  //         width: '100%',
  //         maxWidth: '400px'
  //       }}>
  //         <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>Bandland 2025</h2>
  //         <form onSubmit={handleSubmit}>
  //           <input
  //             type="password"
  //             value={password}
  //             onChange={(e) => setPassword(e.target.value)}
  //             placeholder="Enter password"
  //             style={{
  //               width: '100%',
  //               padding: '12px',
  //               marginBottom: '15px',
  //               border: '1px solid #444',
  //               borderRadius: '5px',
  //               background: '#1a1a1a',
  //               color: '#fff',
  //               fontSize: '16px',
  //               boxSizing: 'border-box'
  //             }}
  //           />
  //           <button
  //             type="submit"
  //             style={{
  //               width: '100%',
  //               padding: '12px',
  //               background: '#e74c3c',
  //               color: '#fff',
  //               border: 'none',
  //               borderRadius: '5px',
  //               fontSize: '16px',
  //               cursor: 'pointer',
  //               fontWeight: 'bold'
  //             }}
  //           >
  //             Enter
  //           </button>
  //         </form>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <BrowserRouter>
      <Helmet>
        <title>Bandland 2026| Rock Festival Bangalore</title>
        <meta name="description" content="Bandland 2026 - Rock music festival in Bangalore" />
      </Helmet>
      
      <Header />
      <Routes >
        <Route path="/" element={<Home />} />
        <Route path="/ticket" element={<Ticket />} />
         <Route path="/faq" element={<Faq />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;